document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bestio-load-more-button]');
  if (!button) return;

  const control = button.closest('[data-bestio-listing-load-more]');
  const nextUrl = control?.dataset.nextUrl;
  const gridId = control?.dataset.gridId;
  if (!control || !nextUrl || !gridId || button.getAttribute('aria-busy') === 'true') return;

  button.setAttribute('aria-busy', 'true');
  button.disabled = true;
  control.classList.add('is-loading');

  try {
    const response = await fetch(nextUrl);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const currentGrid = document.getElementById(gridId);
    const nextGrid = html.getElementById(gridId);
    const nextControl = html.querySelector(`[data-bestio-listing-load-more][data-listing-kind="${control.dataset.listingKind}"]`);
    if (!currentGrid || !nextGrid || !nextControl) throw new Error('Listing response is incomplete');

    nextGrid.querySelectorAll(':scope > .grid-item').forEach((item) => {
      currentGrid.insertAdjacentHTML('beforeend', item.outerHTML);
    });

    const paginationSelector = control.dataset.listingKind === 'search' ? 'nav.pagination-search' : 'nav.pagination';
    const currentPagination = control.parentElement?.querySelector(paginationSelector);
    const nextPagination = nextControl.parentElement?.querySelector(paginationSelector);
    if (currentPagination && nextPagination) currentPagination.replaceWith(nextPagination);

    control.replaceWith(nextControl);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();

    const visibleUrl = new URL(nextUrl, window.location.origin);
    visibleUrl.searchParams.delete('section_id');
    const uniqueTypes = visibleUrl.searchParams.getAll('type');
    if (uniqueTypes.length > 1) {
      visibleUrl.searchParams.delete('type');
      visibleUrl.searchParams.set('type', uniqueTypes[uniqueTypes.length - 1]);
    }
    history.replaceState({ page: Number(nextControl.dataset.currentPage) }, '', `${visibleUrl.pathname}${visibleUrl.search}${visibleUrl.hash}`);
  } catch (error) {
    console.error('Failed to load more products:', error);
    control.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.disabled = false;
  }
});

(() => {
  const mobileViewport = window.matchMedia('(max-width: 767px)');
  let observer;

  const connect = () => {
    observer?.disconnect();
    if (!mobileViewport.matches || !('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const button = entry.target.querySelector('[data-bestio-load-more-button]');
        if (button && button.getAttribute('aria-busy') !== 'true') button.click();
      });
    }, { rootMargin: '600px 0px' });

    document.querySelectorAll('[data-bestio-listing-load-more]').forEach((control) => observer.observe(control));
  };

  const mutationObserver = new MutationObserver(() => requestAnimationFrame(connect));
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  mobileViewport.addEventListener?.('change', connect);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
